export const plannerTranslations = {
  HEB: {
    // ── Signup (singup.tsx) ──────────────────────────────────
    signup: {
      plannerCodeRequired: "קוד המתכנן נדרש",
      plannerCodeInvalid: "קוד המתכנן חייב להכיל רק אותיות אנגליות קטנות, מספרים וקווים (-)",
      plannerCodeTaken: "קוד המתכנן כבר תפוס. נסו קוד אחר.",
      leadsEmailRequired: "אימייל לידים נדרש",
      back: "חזרה",
      plannerDetails: "פרטי מתכנן",
      createAccountAndPay: "צור חשבון מתכנן והמשך לתשלום.",
      note: "שימו לב",
      noteBody:
        "המייל של חשבון המתכנן יהיה המייל הנוכחי שלך במאניטור. את פרטי המיתוג (לוגו/צבעים) אפשר להגדיר אחר כך ב־",
      plannerAccount: "חשבון מתכנן",
      plannerCodeLabel: "קוד המתכנן (באנגלית)",
      plannerCodePlaceholder: "לדוגמה: moshe123",
      plannerCodeHint: "זהו הזיהוי הייחודי שלך והלינק שהלקוחות ישתמשו בו כדי להצטרף אליך.",
      leadsEmailLabel: "אימייל לידים",
      leadsEmailHint: "לכתובת זו יישלחו פניות מלקוחות שרוצים ליצור איתך קשר דרך המערכת.",
      plannerNameLabel: "שם מתכנן/סוכנות (אופציונלי)",
      plannerNamePlaceholder: "שם שיוצג באזור המתכנן",
      checkingAvailability: "בודק זמינות...",
      proceedToPayment: "המשך לתשלום",
      subscriptionIncludes: "מה כולל המנוי?",
      monthlySubscription: "מנוי חודשי",
      perMonth: "/לחודש",
      noVat: "*לא כולל מע״מ",
      upTo300Users: "עד 300 משתמשים",
      upTo100Users: "עד 100 משתמשים",
      features: [
        "אפליקציה ואתר ממותגים אישית ללקוחות שלך",
        "דוחות לקוח חכמים וממותגים",
        "יצירת תובנות AI ללא הגבלה",
        "מנוי חינמי ל־{freeClientUsers} לקוחות שלך בשווי {freeClientValue} בחודש",
        "CRM וניהול לקוחות מובנה",
        "ניהול מסלקה ומסלקה במחיר מוזל",
        "חבילת שיווק וכלים ללידים ללקוחות חדשים",
      ],
      privacyNote: "המידע האישי של הלקוחות לא נחשף לך במערכת; רק הלקוח עצמו יכול לצפות בנתונים שלו.",
      signUpButton: "להרשמה",
    },

    // ── Payment success (payment/success.tsx) ────────────────
    paymentSuccess: {
      successDescription: "ההרשמה בוצעה בהצלחה! חשבון המתכנן שלך הופעל ותוכל להתחיל לעבוד עם לקוחות.",
      checking: "בודקים את פרטי הרכישה...",
      confirmed: "התשלום בוצע בהצלחה!",
      finalizing: "מסיימים את ההקמה...",
      done: "ברוך הבא!",
      timeout: "לא הצלחנו לאמת את התשלום",
      error: "אירעה שגיאה במהלך האימות",
      checkingMessage: "בודקים את פרטי הרכישה...",
      confirmedMessage: "התשלום נקלט. ממשיכים להקמת החשבון...",
      errorMessage: "אירעה שגיאה בבדיקת התשלום. ננסה שוב...",
      timeoutMessage: "לא הצלחנו לאמת את התשלום בתוך 30 שניות. נסו לרענן.",
      missingDetails: "חסרים פרטי הרשמה (LocalStorage). חזרו לעמוד ההרשמה ונסו שוב.",
      finalizingMessage: "מסיימים את ההקמה...",
      continueButton: "המשך",
      retryButton: "נסה שוב",
      checkingSpinnerLabel: "בודקים את פרטי הרכישה",
    },

    // ── Clients (clients.tsx) ────────────────────────────────
    clients: {
      pageTitle: "ניהול לקוחות",
      plannerSystemTitle: "מערכת המתכננים",
      plannerSystemDescription: "צפו בסרטון ההדרכה כדי ללמוד כיצד להשתמש במערכת המתכננים של מאניטור",
      yourLink: "הלינק שלך",
      shareLinkTooltip: "שתפו קישור זה כדי לשייך משתמשים חדשים אליכם",
      copyLink: "העתק קישור",
      linkCopied: "הקישור הועתק ללוח!",
      totalClients: "סה\"כ לקוחות",
      startRecruiting: "התחל לגייס לקוחות חדשים עם הקישור שלך",
      clientCountIncrease: "מספר הלקוחות עלה ב-",
      lastMonth: "בחודש האחרון",
      notifyOnNewClient: "הודיעו לי על לקוח חדש",
      notifyTooltip: "תקבלו הודעת WhatsApp על כל משתמש חדש שנרשם",
      managedWorth: "שווי מנוהל",
      managedWorthTooltip: "קירוב של השווי הנקי הכולל של כל הלקוחות שלך (נכסים פחות חובות)",
      calculating: "מחשב...",
      updateWorth: "עדכן שווי",
      dataAvailable: "נתונים זמינים",
      notCalculatedYet: "לא חושב עדיין",
      clientGrowth: "גידול לקוחות",
      noClientsYet: "אין לקוחות רשומים כרגע",
      noClientsDescription:
        "כדי להתחיל לצבור לקוחות, עליך לשתף איתם את הקישור הייחודי שלך. הלקוחות צריכים להירשם דרך הקישור הזה כדי להיחשב כלקוחות שלך.",
      inviteLinkLabel: "הקישור שלך להזמנת לקוחות:",
      clientsTableTitle: "לקוחות",
      exportCsv: "ייצוא לקוחות ל-CSV",
      searchPlaceholder: "חיפוש...",
      rowsPerPage: "שורות לעמוד",
      fullName: "שם מלא",
      joinDate: "תאריך הצטרפות",
      emailCol: 'דוא"ל',
      phoneCol: "טלפון",
      filesAndNotes: "קבצים/הערות",
      statuses: "סטטוסים",
      sortByName: "מיין לפי שם",
      sortByDate: "מיין לפי תאריך",
      sortByEmail: 'מיין לפי דוא"ל',
      sortByPhone: "מיין לפי טלפון",
      openBankingTooltip: "חיבור לבנקאות פתוחה",
      maslekaTooltip: "מסלקה פנסיונית",
      insightsTooltip: "תובנות",
      notesAndFiles: "הערות וקבצים",
      uploading: "מעלה קובץ...",
      noNotesYet: "אין הערות עדיין.",
      save: "שמור",
      cancel: "ביטול",
      edit: "ערוך",
      delete: "מחק",
      attachFiles: "הוספת קבצים",
      add: "הוסף",
      addNotePlaceholder: "הוסף הערה...",
      total: "סה\"כ:",
      prevPage: "הקודם",
      nextPage: "הבא",
      pageOf: "עמוד {page} מתוך {total}",
      chartDate: "תאריך:",
      chartUsers: "כמות משתמשים:",
      // timeAgo
      justNow: "לפני רגע",
      minuteAgo: "לפני דקה",
      minutesAgo: "לפני {v} דקות",
      hourAgo: "לפני שעה",
      hoursAgo: "לפני {v} שעות",
      dayAgo: "לפני יום",
      daysAgo: "לפני {v} ימים",
      monthAgo: "לפני חודש",
      monthsAgo: "לפני {v} חודשים",
      yearAgo: "לפני שנה",
      yearsAgo: "לפני {v} שנים",
      // Remove user from planner
      removeUser: "הסר מלקוחות",
      removeUserConfirmTitle: "הסרת לקוח",
      removeUserConfirmBody:
        "המשתמש יהפוך למשתמש בסיסי של מאניטור ולא יופיע עוד ברשימת הלקוחות שלך. הנתונים האישיים שלו יישארו במערכת. האם להמשיך?",
      removeUserConfirm: "הסר מלקוחות",
      removeUserCancel: "ביטול",
      removeUserRemoving: "מסיר...",
      removeUserError: "אירעה שגיאה בהסרת הלקוח. נסו שוב.",
      removeUserSuccess: "הלקוח הוסר בהצלחה.",
    },

    // ── Account (account.tsx) ────────────────────────────────
    account: {
      pageTitle: "פרטי חשבון מתכנן",
      uploadError: "שגיאה בהעלאת קובץ: ",
      tabProperties: "פרטי משתמש",
      tabDesign: "עיצוב",
      tabPayment: "תשלום ומנוי",
      username: "שם משתמש",
      yourLink: "הלינק שלך",
      yourLinkTooltip: "זה הלינק שאתה צריך לשתף עם הלקוחות שלך כדי שיצטרפו למערכת תחתיך",
      createdAt: "נוצר ב",
      name: "שם",
      email: 'דוא"ל',
      colorPicker: "בחירת צבעים",
      selectPalette: "בחר פלטה:",
      noPalette: "— ללא —",
      colorType: "סוג צבע",
      pickColor: "בחר צבע",
      currentColor: "צבע כרגע",
      defaultColor: "צבע ברירת מחדל",
      resetToDefault: "איפוס לברירת מחדל",
      reset: "איפוס",
      colorPrimary: "ראשי",
      colorSecondary: "משני",
      colorMenu: "תפריט",
      colorBackground: "רקע",
      colorAccent1: "צבע דגש 1",
      colorAccent2: "צבע דגש 2",
      colorAccent3: "צבע דגש 3",
      logo: "לוגו",
      chooseFile: "בחר קובץ",
      fileChosen: "קובץ נבחר",
      noFileChosen: "לא נבחר קובץ",
      pendingCancelation: "ממתין לביטול",
      canceled: "מבוטל",
      testing: "בתקופת ניסיון",
      active: "פעיל",
      planBusiness300: "Moneytor Business (עד 300 משתמשים)",
      planBusiness100: "Moneytor Business (עד 100 משתמשים)",
      planBusiness: "Moneytor Business",
      price300: "₪499 לחודש (+מע״מ)",
      price100: "₪249 לחודש (+מע״מ)",
      cancelSubscription: "ביטול מנוי",
      cancelConfirmTitle: "בטוחים?",
      cancelConfirmBody:
        "לחיצה על ״ביטול מנוי״ תמחק מיידית את חשבון המתכנן שלך. כל המשתמשים תחתיך (כולל המשתמש שלך) יהפכו למשתמשים בסיסיים של המערכת.",
      cancelConfirmCancel: "התחרטתי",
      cancelError: "אירעה שגיאה בביטול המנוי. נסו שוב.",
      canceling: "מבטלים...",
      cancelConfirmSubmit: "ביטול מנוי",
      cancelNotice: "בקשת הביטול התקבלה. המנוי ימשיך לפעול עד סוף מחזור החיוב הנוכחי.",
      saving: "שומר...",
      saveButton: "שמור",
      // Palette names
      paletteDefault: "ברירת מחדל",
      paletteSunriseWave: "גל זריחה",
      paletteRetroTV: "טלוויזיה רטרו",
      paletteDarkFlowers: "פרחים אפלים",
      paletteNeonFuturistic: "נאון עתידני",
      palettePastelBouquet: "זר פסטלי",
      paletteSantorini: "סנטוריני",
      paletteAlmondBlossom: "פרחי שקד",
      palettePurpleApp: "אפליקציה סגולה",
      paletteMinimalNude: "מינימל ניוד",
      paletteYellowScrewdriver: "מברג צהוב",
      paletteNaturalStone: "אבן טבעית",
      paletteRetroCrowd: "קהל רטרו",
      paletteForestAnimals: "חיות יער",
      paletteOceanDepths: "מעמקי הים",
      paletteRedDeer: "איל אדום",
      paletteArtGallery: "גלריה אמנות",
      paletteWarmPortrait: "פורטרט חם",
      paletteModernVehicle: "רכב מודרני",
      paletteBrightYellow: "צהוב זוהר",
      paletteEarth: "אדמה",
      palettePomegranate: "רימון",
    },

    // ── Insights (insights.tsx, insights.new-ai.tsx, insights.$insightId.tsx) ─
    insights: {
      editInsightsTitle: "עריכת תובנות",
      createInsight: "צור תובנה",
      triggerDescription: "תיאור טריגר",
      summary: "תקציר",
      status: "סטטוס",
      approvedAndActive: "מאושר ופעיל",
      approvedAndInactive: "מאושר ולא פעיל",
      pendingApproval: "ממתין לאישור",
      rejectedStatus: "נדחה",
      rejectionReasonLabel: "סיבת הדחייה",
      activeStatus: "פעיל",
      inactiveStatus: "לא פעיל",
      newAiInsightTitle: "תובנה חדשה - AI",
      createInsightButton: "צור תובנה",
      editInsightTitle: "עריכת תובנה",
      saveChanges: "שמור שינויים",
      somethingWentWrong: "משהו השתבש",
    },

    // ── Resources (resources.tsx) ────────────────────────────
    resources: {
      pageTitle: "משאבים למתכנן",
      description: "בעמוד זה תוכל למצוא חומרים שיווקיים עבור מתכננים פיננסיים.",
      goToCanva: "מעבר למשאבים ב-Canva",
    },

    // ── Invite agent (InviteAgent.tsx) ───────────────────────
    inviteAgent: {
      inviteFailed: "הזמנה נכשלה",
      inviteFailedDetails: "אירעה שגיאה בעת שליחת ההזמנה",
      confirm: "אישור",
      agentCodeRequired: "קוד הסוכן נדרש",
      agentCodeInvalid: "קוד הסוכן חייב להכיל רק אותיות אנגליות קטנות, מספרים וקווים",
      inviteFailedTo: "אירעה שגיאה בעת שליחת ההזמנה ל-",
      inviteSucceeded: "הזמנה נשלחה בהצלחה",
      inviteSucceededTo: "הזמנה לסוכן נשלחה בהצלחה ל-",
      inviteNewAgent: "הזמן סוכן חדש",
      createAgentAndInvite: "צור סוכן חדש והזמן משתמש לנהל אותו",
      inviteUserSection: "הזמנת משתמש",
      infoBox: "ניתן להזמין משתמשים שעדיין לא רשומים במערכת מאניטור. ההזמנה תחכה להם ותופיע ברגע שהם יצטרפו למערכת.",
      userEmailLabel: "אימייל המשתמש להזמנה",
      userEmailTooltip: "זה המייל של המשתמש במאניטור שינהל את חשבון הסוכן",
      agentCodeLabel: "קוד הסוכן (באנגלית)",
      agentCodeTooltip:
        "קוד הסוכן חייב להכיל רק אותיות אנגליות קטנות (a-z), מספרים (0-9) וקווים (-). לדוגמה: john-doe, agent123, my-agent",
      agentCodeNote: "קוד הסוכן הוא הזיהוי הייחודי שלו במערכת וקובע את הלינק שהוא ישתף עם המשתמשים שלו כדי שיצטרפו תחתיו.",
      agentCodeExample: "דוגמה:",
      agentCodeExampleCode: "קוד:",
      agentCodeExampleLink: "לינק הזמנה:",
      agentEmailLabel: "אימייל הסוכן (אופציונלי)",
      agentEmailTooltip: "המייל אליו יגיעו הלידים מהמערכת",
      agentNameLabel: "שם הסוכן (אופציונלי)",
      agentLogoLabel: "לוגו הסוכן (אופציונלי)",
      chooseFile: "בחר קובץ",
      fileChosen: "קובץ נבחר",
      noFileChosen: "לא נבחר קובץ",
      createAndInviteButton: "צור והזמן",
    },

    // ── Masleka purchase modal (MaslekaPurchaseModal.tsx) ────
    maslekaPurchase: {
      modalTitle: "רכישת מסלקות עבור לקוחות",
      description: "הזינו את המסלקות שברצונך לרכוש",
      decreaseQty: "הפחת כמות",
      increaseQty: "הוסף כמות",
      upTo20: "עד 20 מסלקות",
      above20: "מעל 20 מסלקות",
      perRenewable: "למסלקה מתחדשת",
      renewableInfo: "המסלקה היא מתחדשת חודשית במשך שנה (12 קריאות)",
      priceNote: "אנחנו יודעים שאתם משלמים 14 ש״ח למסלקה. פה מדובר ב12 מסלקות אז קיבלתם אחלה מחיר, אין בעד מה",
      savedDiscount: "חסכתם ₪{amount} בזכות ההנחה!",
      totalCost: "עלות כוללת",
      receiptNameLabel: "שם שיופיע בקבלה",
      receiptNamePlaceholder: "שם פרטי ושם משפחה",
      proceedToPayment: "המשך לתשלום",
      cancelButton: "בטל",
    },

    // ── Masleka Management (MaslekaManagement.tsx) ───────────
    maslekaManagement: {
      clientsAndBudget: "ניהול לקוחות ותקציב",
      maslekaSettings: "הגדרות מסלקה",
      maslekaManagement: "ניהול מסלקה",
      defaultPaymentMode: "בחירת ברירת מחדל אופן התשלום",
      canChangePerClient: "ניתן לשנות לכל לקוח בנפרד בהמשך",
      canChangePerClientLater: "ניתן בהמשך לשנות את ההגדרה עבור כל לקוח בנפרד",
      paymentInfo: "התשלום הוא עבור מסלקה לשנה (12 קריאות), המידע מתעדכן כל חודש ולוקח לו עד 3 ימי עסקים להגיע.",
      customersWillPay: "הלקוחות ישלמו",
      customersWillPayDesc: "ישלמו ₪35 לפני ביצוע קריאה למסלקה",
      iWillPay: "אני אשלם",
      iWillPayDesc: "בהתאם להגדרת התקציב שיוגדר",
      alerts: "התראות",
      notifyOnOrder: "הודיעו לי כשלקוח שלי מזמין מסלקה",
      saving: "שומר...",
      save: "שמירה",
      purchasedCount: "כמות מסלקות שקניתם",
      usedCount: "כמות מסלקות שנוצלו",
      remainingBalance: "יתרה לשימוש",
      missingDetails: "חסרים פרטים אישיים. האם תרצה לעדכן אותם כעת?",
      purchaseBudget: "רכישת תקציב מסלקות",
      clientName: "שם לקוח",
      email: "אימייל",
      joinDate: "תאריך הצטרפות",
      maslekaPayment: "תשלום עבור מסלקה",
      markAll: "סמן הכול",
      statusCol: "סטטוס",
      infoStatus: "סטטוס מידע",
      dataArrived: "המידע הגיע",
      dataOnTheWay: "המידע בדרך",
      processCanceled: "התהליך התבטל באמצע",
      processStarted: "התהליך התחיל",
      notOrdered: "לא הוזמנה מסלקה",
      registered: "רשום/ה במסלקה",
      noClients: "אין לקוחות להצגה כרגע.",
      quotaExhaustedTitle: "תקציב המסלקות נגמר!",
      quotaExhaustedDesc: "נגמרו לך המסלקות בתקציב, מומלץ לרכוש עוד בהקדם",
      dontShowAgain: "אל תציג שוב",
      purchaseMore: "רכישת עוד מסלקות",
      free: "חינם",
      notActive: "לא פעיל",
      saveError: "השמירה נכשלה, נסו שוב",
    },

    // ── Masleka route (masleka.tsx) ─────────────────────────────
    maslekaRoute: {
      pensionClearingReceipt: "מסלקה פנסיונית",
    },

    // ── Insight Tab Navigation (InsightTabNavigation.tsx) ─────
    insightTabs: {
      assetInsights: "תובנות נכסים",
      cashflowInsights: "תובנות תזרים",
      cannotChangeType: "לא ניתן לשנות את סוג התובנה בעריכה",
    },

    // ── AI Trigger Form (AITriggerForm.tsx) ───────────────────
    aiTriggerForm: {
      assetInsight: "תובנת נכסים",
      cashflowInsight: "תובנת תזרים",
      assetInsightDesc: "התובנה תתבסס על נכסי המשתמש והתחייבויותיו, אך לא על נתוני התזרים שלו",
      cashflowInsightDesc: "התובנה תתבסס על התזרים של המשתמש: כל התנועות של כרטיסי האשראי וחשבונות הבנק",
      readOnly: "קריאה בלבד",
      approvedAISettings: "הגדרות AI מאושרות",
      approvedAISettingsDesc: "הגדרות ה-AI של תובנה זו אושרו ולא ניתן לשנותן. ניתן לראות את ההגדרות לצורך עיון בלבד או לבטל את האישור כדי לאפשר עריכה.",
      aiTrigger: "טריגר AI",
      aiTriggerTooltipAssets: "תיאור התנאי שבו התובנה צריכה להופיע. למשל: 'אם יש יותר מ-100,000 שקל בחשבון הבנק'",
      aiTriggerTooltipCashflow: "תיאור התנאי שבו התובנה צריכה להופיע על בסיס עסקאות. למשל: 'אם יש יותר מ-5 עסקאות במסעדות החודש'",
      aiTriggerPlaceholderAssets: "דוגמה: אם יש יותר מ-50,000 שקל בחשבון הבנק",
      aiTriggerPlaceholderCashflow: "דוגמה: אם יש יותר מ-10 עסקאות במסעדות החודש",
      extraDataLabel: "מידע נוסף לבינה המלאכותית",
      extraDataTooltip: "מידע נוסף שיעזור לבינה המלאכותית ליצור קוד מדויק יותר. למשל: רשימת ספקי פנסיה, מילות מפתח שמופיעות בעסקאות, וכו'",
      extraDataPlaceholderAssets: "דוגמה: רשימת ספקי פנסיה: מגדל, הראל, כלל, מנורה מבטחים",
      extraDataPlaceholderCashflow: "דוגמה: מילות מפתח למסעדות: מקדונלדס, בורגר קינג, פיצה האט, דומינוס",
      customParams: "פרמטרים מותאמים",
      customParamsTooltip: "פרמטרים שהפונקציה תחזיר בנוסף לתוצאה הרגילה. כל פרמטר יוצג עם מספר זהות {1}, {2} וכו'",
      paramDescription: "תיאור הפרמטר...",
      remove: "הסר",
      addParam: "הוסף פרמטר",
      checking: "בודק...",
      checkAndGenerate: "בדוק וצור קוד",
    },

    // ── Insight Main Form (InsightMainForm.tsx) ───────────────
    insightMainForm: {
      insightSettings: "הגדרות תובנה",
      approvedInsight: "תובנה מאושרת",
      approvedInsightDesc: "תובנה זו אושרה ולכן רוב השדות נעולים לעריכה. ניתן רק לשנות את הסטטוס הפעיל, לבטל אישור, או למחוק את התובנה.",
      activeStatus: "סטטוס פעיל",
      activeStatusTooltip: "כאן ניתן לסמן האם אתם רוצים שהתובנה תופיע או לא. אם זה מסומן, התובנה תוצג ללקוחות. אם מורידים את הסימון, התובנה לא תוצג.",
      triggerDescription: "תיאור טריגר",
      triggerDescriptionTooltip: "תיאור קצר של התנאי שמפעיל את התובנה. מופיע בטבלת התובנות.",
      summary: "תקציר",
      summaryTooltip: "זוהי התראה קצרה שתקפוץ ללקוח. אם ילחץ עליה, תיפתח לו התובנה הגדולה.",
      title: "כותרת",
      titleTooltip: "זוהי הכותרת של התובנה. עדיף שתהיה שורה או שתיים.",
      body: "תוכן",
      bodyTooltip: "זה גוף התובנה. חשוב שיהיה שונה מהכותרת באופן ברור.",
      buttonText: "טקסט כפתור",
      buttonTextTooltip: "זה מלל קצר שיופיע על הכפתור.",
      externalLink: "קישור חיצוני של הכפתור",
      externalLinkTooltip: "זה הלינק של הכפתור. אם יש לינק, הלקוח יועבר אליו.",
      podcastUrl: "כתובת ״האזן לפודקאסט״",
      podcastUrlTooltip: "זה לינק לפודקאסט אם רוצים (לא חובה)",
      videoUrl: "כתובת ״צפה בסרטון״",
      videoUrlTooltip: "זה לינק לסרטון וידאו חיצוני (לא חובה)",
      iframeUrl: "כתובת וידאו מוטמע",
      iframeUrlTooltip: "זה לינק לוידאו שמוצג בתוך התובנה מצד שמאל.",
      reportText: "טקסט דוח",
      reportTextTooltip: "זה טקסט מקוצר שמיועד לדוחות ולמתכננים. יכיל את המידע המרכזי של התובנה בצורה מקצועית ותמציתית.",
      reportTextPlaceholder: "טקסט מקוצר עבור דוחות ומתכננים...",
      updating: "מעדכן...",
      updateStatus: "עדכן סטטוס",
      savingEllipsis: "שומר...",
      disableApproval: "בטל אישור",
      disableApprovalConfirm: "האם אתה בטוח שברצונך לבטל את האישור? פעולה זו תאפשר עריכה אבל תבטל את התובנה עבור המשתמשים עד לאישור מחדש",
      deleteInsight: "מחק תובנה",
      deleteInsightConfirm: "האם אתה בטוח שברצונך למחוק את התובנה? פעולה זו תמחק גם את כל התובנות הקשורות של המשתמשים.",
      restoreDefault: "שחזר לתובנת ברירת מחדל",
      hebrewTab: "עברית",
      englishTab: "English",
    },
  },

  ENG: {
    // ── Signup (singup.tsx) ──────────────────────────────────
    signup: {
      plannerCodeRequired: "Planner code is required",
      plannerCodeInvalid: "Planner code must contain only lowercase letters, numbers, and hyphens (-)",
      plannerCodeTaken: "This planner code is already taken. Try a different one.",
      leadsEmailRequired: "Leads email is required",
      back: "Back",
      plannerDetails: "Planner Details",
      createAccountAndPay: "Create a planner account and proceed to payment.",
      note: "Please note",
      noteBody:
        "The planner account email will be your current Moneytor email. Branding details (logo/colors) can be set later in ",
      plannerAccount: "Planner Account",
      plannerCodeLabel: "Planner Code (English)",
      plannerCodePlaceholder: "e.g. moshe123",
      plannerCodeHint: "This is your unique identifier and the link your clients will use to join you.",
      leadsEmailLabel: "Leads Email",
      leadsEmailHint: "Client enquiries sent through the system will be forwarded to this address.",
      plannerNameLabel: "Planner / Agency Name (optional)",
      plannerNamePlaceholder: "Name displayed in the planner area",
      checkingAvailability: "Checking availability...",
      proceedToPayment: "Proceed to Payment",
      subscriptionIncludes: "What's Included?",
      monthlySubscription: "Monthly Subscription",
      perMonth: "/month",
      noVat: "*Excluding VAT",
      upTo300Users: "Up to 300 users",
      upTo100Users: "Up to 100 users",
      features: [
        "Branded app & website for your clients",
        "Smart branded client reports",
        "Unlimited AI insight generation",
        "Free subscription for {freeClientUsers} of your clients worth {freeClientValue}/month",
        "Built-in CRM & client management",
        "Pension Masleka management at a discounted price",
        "Marketing kit & tools for acquiring new clients",
      ],
      privacyNote: "Client personal information is not exposed to you in the system; only the client themselves can view their data.",
      signUpButton: "Sign Up",
    },

    // ── Payment success (payment/success.tsx) ────────────────
    paymentSuccess: {
      successDescription: "Registration completed successfully! Your planner account is now active and you can start working with clients.",
      checking: "Verifying purchase details...",
      confirmed: "Payment successful!",
      finalizing: "Finishing setup...",
      done: "Welcome!",
      timeout: "Unable to verify payment",
      error: "An error occurred during verification",
      checkingMessage: "Verifying purchase details...",
      confirmedMessage: "Payment received. Setting up your account...",
      errorMessage: "An error occurred while checking the payment. Retrying...",
      timeoutMessage: "Unable to verify payment within 30 seconds. Try refreshing.",
      missingDetails: "Missing registration details (LocalStorage). Return to the signup page and try again.",
      finalizingMessage: "Finishing setup...",
      continueButton: "Continue",
      retryButton: "Try Again",
      checkingSpinnerLabel: "Verifying purchase details",
    },

    // ── Clients (clients.tsx) ────────────────────────────────
    clients: {
      pageTitle: "Client Management",
      plannerSystemTitle: "Planner System",
      plannerSystemDescription: "Watch the tutorial video to learn how to use the Moneytor planner system",
      yourLink: "Your Link",
      shareLinkTooltip: "Share this link to associate new users with you",
      copyLink: "Copy Link",
      linkCopied: "Link copied to clipboard!",
      totalClients: "Total Clients",
      startRecruiting: "Start recruiting new clients with your link",
      clientCountIncrease: "Client count increased by ",
      lastMonth: " last month",
      notifyOnNewClient: "Notify me of new clients",
      notifyTooltip: "You'll receive a WhatsApp message for every new user who signs up",
      managedWorth: "Managed Worth",
      managedWorthTooltip: "Approximation of the total net worth of all your clients (assets minus liabilities)",
      calculating: "Calculating...",
      updateWorth: "Update Worth",
      dataAvailable: "Data available",
      notCalculatedYet: "Not calculated yet",
      clientGrowth: "Client Growth",
      noClientsYet: "No registered clients yet",
      noClientsDescription:
        "To start accumulating clients, share your unique link with them. Clients need to register through this link to be counted as your clients.",
      inviteLinkLabel: "Your client invitation link:",
      clientsTableTitle: "Clients",
      exportCsv: "Export Clients to CSV",
      searchPlaceholder: "Search...",
      rowsPerPage: "Rows per page",
      fullName: "Full Name",
      joinDate: "Join Date",
      emailCol: "Email",
      phoneCol: "Phone",
      filesAndNotes: "Files/Notes",
      statuses: "Statuses",
      sortByName: "Sort by name",
      sortByDate: "Sort by date",
      sortByEmail: "Sort by email",
      sortByPhone: "Sort by phone",
      openBankingTooltip: "Open banking connection",
      maslekaTooltip: "Pension Masleka",
      insightsTooltip: "Insights",
      notesAndFiles: "Notes & Files",
      uploading: "Uploading file...",
      noNotesYet: "No notes yet.",
      save: "Save",
      cancel: "Cancel",
      edit: "Edit",
      delete: "Delete",
      attachFiles: "Attach Files",
      add: "Add",
      addNotePlaceholder: "Add a note...",
      total: "Total:",
      prevPage: "Previous",
      nextPage: "Next",
      pageOf: "Page {page} of {total}",
      chartDate: "Date:",
      chartUsers: "Users:",
      // timeAgo
      justNow: "just now",
      minuteAgo: "a minute ago",
      minutesAgo: "{v} minutes ago",
      hourAgo: "an hour ago",
      hoursAgo: "{v} hours ago",
      dayAgo: "a day ago",
      daysAgo: "{v} days ago",
      monthAgo: "a month ago",
      monthsAgo: "{v} months ago",
      yearAgo: "a year ago",
      yearsAgo: "{v} years ago",
      // Remove user from planner
      removeUser: "Remove from clients",
      removeUserConfirmTitle: "Remove client",
      removeUserConfirmBody:
        "This user will become a regular Moneytor user and will no longer appear in your client list. Their personal data will remain in the system. Continue?",
      removeUserConfirm: "Remove from clients",
      removeUserCancel: "Cancel",
      removeUserRemoving: "Removing...",
      removeUserError: "An error occurred while removing the client. Please try again.",
      removeUserSuccess: "Client removed successfully.",
    },

    // ── Account (account.tsx) ────────────────────────────────
    account: {
      pageTitle: "Planner Account Details",
      uploadError: "Error uploading file: ",
      tabProperties: "User Details",
      tabDesign: "Design",
      tabPayment: "Payment & Subscription",
      username: "Username",
      yourLink: "Your Link",
      yourLinkTooltip: "This is the link you need to share with your clients so they join the system under you",
      createdAt: "Created at",
      name: "Name",
      email: "Email",
      colorPicker: "Color Selection",
      selectPalette: "Select palette:",
      noPalette: "— None —",
      colorType: "Color type",
      pickColor: "Pick color",
      currentColor: "Current color",
      defaultColor: "Default color",
      resetToDefault: "Reset to default",
      reset: "Reset",
      colorPrimary: "Primary",
      colorSecondary: "Secondary",
      colorMenu: "Menu",
      colorBackground: "Background",
      colorAccent1: "Accent 1",
      colorAccent2: "Accent 2",
      colorAccent3: "Accent 3",
      logo: "Logo",
      chooseFile: "Choose file",
      fileChosen: "File chosen",
      noFileChosen: "No file chosen",
      pendingCancelation: "Pending cancellation",
      canceled: "Canceled",
      testing: "Trial period",
      active: "Active",
      planBusiness300: "Moneytor Business (up to 300 users)",
      planBusiness100: "Moneytor Business (up to 100 users)",
      planBusiness: "Moneytor Business",
      price300: "₪499/month (+VAT)",
      price100: "₪249/month (+VAT)",
      cancelSubscription: "Cancel Subscription",
      cancelConfirmTitle: "Are you sure?",
      cancelConfirmBody:
        'Clicking "Cancel Subscription" will immediately delete your planner account. All users under you (including your own user) will become basic users.',
      cancelConfirmCancel: "Never mind",
      cancelError: "An error occurred while canceling the subscription. Please try again.",
      canceling: "Canceling...",
      cancelConfirmSubmit: "Cancel Subscription",
      cancelNotice: "Cancellation request received. The subscription will remain active until the end of the current billing cycle.",
      saving: "Saving...",
      saveButton: "Save",
      // Palette names
      paletteDefault: "Default",
      paletteSunriseWave: "Sunrise Wave",
      paletteRetroTV: "Retro TV",
      paletteDarkFlowers: "Dark Flowers",
      paletteNeonFuturistic: "Neon Futuristic",
      palettePastelBouquet: "Pastel Bouquet",
      paletteSantorini: "Santorini",
      paletteAlmondBlossom: "Almond Blossom",
      palettePurpleApp: "Purple App",
      paletteMinimalNude: "Minimal Nude",
      paletteYellowScrewdriver: "Yellow Screwdriver",
      paletteNaturalStone: "Natural Stone",
      paletteRetroCrowd: "Retro Crowd",
      paletteForestAnimals: "Forest Animals",
      paletteOceanDepths: "Ocean Depths",
      paletteRedDeer: "Red Deer",
      paletteArtGallery: "Art Gallery",
      paletteWarmPortrait: "Warm Portrait",
      paletteModernVehicle: "Modern Vehicle",
      paletteBrightYellow: "Bright Yellow",
      paletteEarth: "Earth",
      palettePomegranate: "Pomegranate",
    },

    // ── Insights (insights.tsx, insights.new-ai.tsx, insights.$insightId.tsx) ─
    insights: {
      editInsightsTitle: "Edit Insights",
      createInsight: "Create Insight",
      triggerDescription: "Trigger Description",
      summary: "Summary",
      status: "Status",
      approvedAndActive: "Approved & Active",
      approvedAndInactive: "Approved & Inactive",
      pendingApproval: "Pending Approval",
      rejectedStatus: "Rejected",
      rejectionReasonLabel: "Rejection reason",
      activeStatus: "Active",
      inactiveStatus: "Inactive",
      newAiInsightTitle: "New Insight - AI",
      createInsightButton: "Create Insight",
      editInsightTitle: "Edit Insight",
      saveChanges: "Save Changes",
      somethingWentWrong: "Something went wrong",
    },

    // ── Resources (resources.tsx) ────────────────────────────
    resources: {
      pageTitle: "Planner Resources",
      description: "On this page you can find marketing materials for financial planners.",
      goToCanva: "Go to Canva Resources",
    },

    // ── Invite agent (InviteAgent.tsx) ───────────────────────
    inviteAgent: {
      inviteFailed: "Invitation Failed",
      inviteFailedDetails: "An error occurred while sending the invitation",
      confirm: "OK",
      agentCodeRequired: "Agent code is required",
      agentCodeInvalid: "Agent code must contain only lowercase letters, numbers, and hyphens",
      inviteFailedTo: "An error occurred while sending the invitation to ",
      inviteSucceeded: "Invitation Sent Successfully",
      inviteSucceededTo: "Agent invitation sent successfully to ",
      inviteNewAgent: "Invite New Agent",
      createAgentAndInvite: "Create a new agent and invite a user to manage it",
      inviteUserSection: "Invite User",
      infoBox: "You can invite users who aren't registered in Moneytor yet. The invitation will wait for them and appear once they join the system.",
      userEmailLabel: "User email for invitation",
      userEmailTooltip: "This is the Moneytor user email that will manage the agent account",
      agentCodeLabel: "Agent Code (English)",
      agentCodeTooltip:
        "Agent code must contain only lowercase letters (a-z), numbers (0-9), and hyphens (-). Examples: john-doe, agent123, my-agent",
      agentCodeNote: "The agent code is their unique identifier in the system and determines the link they share with users to join under them.",
      agentCodeExample: "Example:",
      agentCodeExampleCode: "Code:",
      agentCodeExampleLink: "Invitation link:",
      agentEmailLabel: "Agent Email (optional)",
      agentEmailTooltip: "Leads from the system will be sent to this email",
      agentNameLabel: "Agent Name (optional)",
      agentLogoLabel: "Agent Logo (optional)",
      chooseFile: "Choose file",
      fileChosen: "File chosen",
      noFileChosen: "No file chosen",
      createAndInviteButton: "Create & Invite",
    },

    // ── Masleka purchase modal (MaslekaPurchaseModal.tsx) ────
    maslekaPurchase: {
      modalTitle: "Purchase Pension Masleka for Clients",
      description: "Enter the number of pension Masleka you wish to purchase",
      decreaseQty: "Decrease quantity",
      increaseQty: "Increase quantity",
      upTo20: "Up to 20 Masleka",
      above20: "Over 20 Masleka",
      perRenewable: "per renewable Masleka",
      renewableInfo: "Masleka is renewed monthly for one year (12 calls)",
      priceNote: "We know you pay ₪14 per Masleka. This is for 12 Masleka, so you got a great price — you're welcome!",
      savedDiscount: "You saved ₪{amount} thanks to the discount!",
      totalCost: "Total cost",
      receiptNameLabel: "Name on receipt",
      receiptNamePlaceholder: "First and last name",
      proceedToPayment: "Proceed to Payment",
      cancelButton: "Cancel",
    },

    // ── Masleka Management (MaslekaManagement.tsx) ───────────
    maslekaManagement: {
      clientsAndBudget: "Clients & Budget Management",
      maslekaSettings: "Masleka Settings",
      maslekaManagement: "Masleka Management",
      defaultPaymentMode: "Default Payment Mode",
      canChangePerClient: "Can be changed per client later",
      canChangePerClientLater: "You can change this setting for each client individually later",
      paymentInfo: "Payment is for one year of pension Masleka (12 calls). Data is updated monthly and takes up to 3 business days to arrive.",
      customersWillPay: "Customers will pay",
      customersWillPayDesc: "They will pay ₪35 before each Masleka call",
      iWillPay: "I will pay",
      iWillPayDesc: "According to the configured budget",
      alerts: "Alerts",
      notifyOnOrder: "Notify me when a client orders a Masleka",
      saving: "Saving...",
      save: "Save",
      purchasedCount: "Masleka Purchased",
      usedCount: "Masleka Used",
      remainingBalance: "Remaining Balance",
      missingDetails: "Missing personal details. Would you like to update them now?",
      purchaseBudget: "Purchase Masleka Budget",
      clientName: "Client Name",
      email: "Email",
      joinDate: "Join Date",
      maslekaPayment: "Masleka Payment",
      markAll: "Mark all",
      statusCol: "Status",
      infoStatus: "Info Status",
      dataArrived: "Data arrived",
      dataOnTheWay: "Data on the way",
      processCanceled: "Process was canceled",
      processStarted: "Process started",
      notOrdered: "Masleka not ordered",
      registered: "Registered for Masleka",
      noClients: "No clients to display at this time.",
      quotaExhaustedTitle: "Masleka Budget Exhausted!",
      quotaExhaustedDesc: "Your Masleka budget is used up. It's recommended to purchase more soon.",
      dontShowAgain: "Don't show again",
      purchaseMore: "Purchase More Masleka",
      free: "Free",
      notActive: "Not active",
      saveError: "Saving failed, please try again",
    },

    // ── Masleka route (masleka.tsx) ─────────────────────────────
    maslekaRoute: {
      pensionClearingReceipt: "Pension Masleka",
    },

    // ── Insight Tab Navigation ────────────────────────────────
    insightTabs: {
      assetInsights: "Asset Insights",
      cashflowInsights: "Cashflow Insights",
      cannotChangeType: "Cannot change insight type while editing",
    },

    // ── AI Trigger Form (AITriggerForm.tsx) ───────────────────
    aiTriggerForm: {
      assetInsight: "Asset Insight",
      cashflowInsight: "Cashflow Insight",
      assetInsightDesc: "The insight will be based on the user's assets and liabilities, but not on their cashflow data",
      cashflowInsightDesc: "The insight will be based on the user's cashflow: all credit card and bank account transactions",
      readOnly: "Read only",
      approvedAISettings: "Approved AI Settings",
      approvedAISettingsDesc: "The AI settings for this insight have been approved and cannot be changed. You can view the settings for reference only or revoke approval to enable editing.",
      aiTrigger: "AI Trigger",
      aiTriggerTooltipAssets: "Describe the condition under which the insight should appear. E.g.: 'If there is more than 100,000 NIS in the bank account'",
      aiTriggerTooltipCashflow: "Describe the condition under which the insight should appear based on transactions. E.g.: 'If there are more than 5 restaurant transactions this month'",
      aiTriggerPlaceholderAssets: "Example: If there is more than 50,000 NIS in the bank account",
      aiTriggerPlaceholderCashflow: "Example: If there are more than 10 restaurant transactions this month",
      extraDataLabel: "Additional Data for AI",
      extraDataTooltip: "Additional information to help AI generate more accurate code. E.g.: list of pension providers, keywords in transactions, etc.",
      extraDataPlaceholderAssets: "Example: Pension provider list: Migdal, Harel, Clal, Menora Mivtachim",
      extraDataPlaceholderCashflow: "Example: Restaurant keywords: McDonald's, Burger King, Pizza Hut, Domino's",
      customParams: "Custom Parameters",
      customParamsTooltip: "Parameters the function will return in addition to the regular result. Each parameter will be displayed with ID {1}, {2}, etc.",
      paramDescription: "Parameter description...",
      remove: "Remove",
      addParam: "Add Parameter",
      checking: "Checking...",
      checkAndGenerate: "Check & Generate Code",
    },

    // ── Insight Main Form (InsightMainForm.tsx) ───────────────
    insightMainForm: {
      insightSettings: "Insight Settings",
      approvedInsight: "Approved Insight",
      approvedInsightDesc: "This insight has been approved so most fields are locked. You can only change the active status, revoke approval, or delete the insight.",
      activeStatus: "Active Status",
      activeStatusTooltip: "Here you can set whether the insight should appear or not. If checked, the insight will be shown to clients. If unchecked, it won't be shown.",
      triggerDescription: "Trigger Description",
      triggerDescriptionTooltip: "A short description of the condition that triggers this insight. Shown in the insights table.",
      summary: "Summary",
      summaryTooltip: "This is a short alert that will pop up for the client. If they click it, the full insight will open.",
      title: "Title",
      titleTooltip: "This is the insight title. Preferably one or two lines.",
      body: "Content",
      bodyTooltip: "This is the insight body. It should clearly differ from the title.",
      buttonText: "Button Text",
      buttonTextTooltip: "Short text that will appear on the button.",
      externalLink: "Button External Link",
      externalLinkTooltip: "This is the button link. If provided, the client will be redirected to it.",
      podcastUrl: "Podcast URL",
      podcastUrlTooltip: "Link to a podcast (optional)",
      videoUrl: "Video URL",
      videoUrlTooltip: "Link to an external video (optional)",
      iframeUrl: "Embedded Video URL",
      iframeUrlTooltip: "Link to a video displayed inside the insight on the left side.",
      reportText: "Report Text",
      reportTextTooltip: "Condensed text for reports and planners. Contains the key insight information in a professional and concise format.",
      reportTextPlaceholder: "Condensed text for reports and planners...",
      updating: "Updating...",
      updateStatus: "Update Status",
      savingEllipsis: "Saving...",
      disableApproval: "Revoke Approval",
      disableApprovalConfirm: "Are you sure you want to revoke the approval? This will enable editing but will deactivate the insight for users until re-approved.",
      deleteInsight: "Delete Insight",
      deleteInsightConfirm: "Are you sure you want to delete this insight? This will also delete all related user insights.",
      restoreDefault: "Restore Default Insight",
      hebrewTab: "עברית",
      englishTab: "English",
    },
  },

  RUS: {
    // ── Signup (singup.tsx) ──────────────────────────────────
    signup: {
      plannerCodeRequired: "Код планировщика обязателен",
      plannerCodeInvalid: "Код планировщика должен содержать только строчные латинские буквы, цифры и дефисы (-)",
      plannerCodeTaken: "Этот код планировщика уже занят. Попробуйте другой.",
      leadsEmailRequired: "Email для лидов обязателен",
      back: "Назад",
      plannerDetails: "Данные планировщика",
      createAccountAndPay: "Создайте аккаунт планировщика и перейдите к оплате.",
      note: "Обратите внимание",
      noteBody:
        "Email аккаунта планировщика будет вашим текущим email. Настройки брендинга (логотип/цвета) можно задать позже в ",
      plannerAccount: "Аккаунт планировщика",
      plannerCodeLabel: "Код планировщика (на английском)",
      plannerCodePlaceholder: "Например: moshe123",
      plannerCodeHint: "Это ваш уникальный идентификатор и ссылка, по которой клиенты смогут присоединиться к вам.",
      leadsEmailLabel: "Email для лидов",
      leadsEmailHint: "На этот адрес будут отправляться запросы от клиентов через систему.",
      plannerNameLabel: "Имя планировщика/агентства (необязательно)",
      plannerNamePlaceholder: "Имя, отображаемое в разделе планировщика",
      checkingAvailability: "Проверка доступности...",
      proceedToPayment: "Перейти к оплате",
      subscriptionIncludes: "Что включено?",
      monthlySubscription: "Ежемесячная подписка",
      perMonth: "/месяц",
      noVat: "*Без НДС",
      upTo300Users: "До 300 пользователей",
      upTo100Users: "До 100 пользователей",
      features: [
        "Брендированное приложение и сайт для ваших клиентов",
        "Умные брендированные отчёты для клиентов",
        "Неограниченная генерация AI-инсайтов",
        "Бесплатная подписка для {freeClientUsers} ваших клиентов стоимостью {freeClientValue}/месяц",
        "Встроенная CRM и управление клиентами",
        "Управление пенсионной маслекой по сниженной цене",
        "Маркетинговый пакет и инструменты для привлечения новых клиентов",
      ],
      privacyNote: "Персональные данные клиентов не раскрываются вам в системе; только сам клиент может просматривать свои данные.",
      signUpButton: "Регистрация",
    },

    // ── Payment success (payment/success.tsx) ────────────────
    paymentSuccess: {
      successDescription: "Регистрация прошла успешно! Ваш аккаунт планировщика активирован, и вы можете начать работу с клиентами.",
      checking: "Проверка данных покупки...",
      confirmed: "Оплата прошла успешно!",
      finalizing: "Завершение настройки...",
      done: "Добро пожаловать!",
      timeout: "Не удалось подтвердить оплату",
      error: "Произошла ошибка при проверке",
      checkingMessage: "Проверка данных покупки...",
      confirmedMessage: "Оплата получена. Настраиваем ваш аккаунт...",
      errorMessage: "Произошла ошибка при проверке оплаты. Повторная попытка...",
      timeoutMessage: "Не удалось подтвердить оплату в течение 30 секунд. Попробуйте обновить страницу.",
      missingDetails: "Отсутствуют данные регистрации (LocalStorage). Вернитесь на страницу регистрации и попробуйте снова.",
      finalizingMessage: "Завершение настройки...",
      continueButton: "Продолжить",
      retryButton: "Попробовать снова",
      checkingSpinnerLabel: "Проверка данных покупки",
    },

    // ── Clients (clients.tsx) ────────────────────────────────
    clients: {
      pageTitle: "Клиенты",
      plannerSystemTitle: "Система планировщика",
      plannerSystemDescription: "Посмотрите обучающее видео, чтобы узнать, как использовать систему планировщика",
      yourLink: "Ваша ссылка",
      shareLinkTooltip: "Поделитесь этой ссылкой, чтобы привязать новых пользователей к себе",
      copyLink: "Копировать ссылку",
      linkCopied: "Ссылка скопирована в буфер обмена!",
      totalClients: "Всего клиентов",
      startRecruiting: "Начните привлекать новых клиентов по вашей ссылке",
      clientCountIncrease: "Количество клиентов увеличилось на ",
      lastMonth: " за последний месяц",
      notifyOnNewClient: "Уведомлять о новых клиентах",
      notifyTooltip: "Вы получите сообщение в WhatsApp при каждой новой регистрации",
      managedWorth: "Управляемая стоимость",
      managedWorthTooltip: "Приблизительная общая чистая стоимость всех ваших клиентов (активы минус обязательства)",
      calculating: "Расчёт...",
      updateWorth: "Обновить стоимость",
      dataAvailable: "Данные доступны",
      notCalculatedYet: "Ещё не рассчитано",
      clientGrowth: "Рост клиентской базы",
      noClientsYet: "Пока нет зарегистрированных клиентов",
      noClientsDescription:
        "Чтобы начать привлекать клиентов, поделитесь с ними вашей уникальной ссылкой. Клиенты должны зарегистрироваться по этой ссылке, чтобы быть привязанными к вам.",
      inviteLinkLabel: "Ваша ссылка для приглашения клиентов:",
      clientsTableTitle: "Клиенты",
      exportCsv: "Экспорт клиентов в CSV",
      searchPlaceholder: "Поиск...",
      rowsPerPage: "Строк на стр.",
      fullName: "Имя",
      joinDate: "Дата",
      emailCol: "Email",
      phoneCol: "Телефон",
      filesAndNotes: "Файлы/Заметки",
      statuses: "Статусы",
      sortByName: "По имени",
      sortByDate: "По дате",
      sortByEmail: "По email",
      sortByPhone: "По телефону",
      openBankingTooltip: "Подключение к открытому банкингу",
      maslekaTooltip: "Пенсионная маслека",
      insightsTooltip: "Инсайты",
      notesAndFiles: "Заметки и файлы",
      uploading: "Загрузка файла...",
      noNotesYet: "Заметок пока нет.",
      save: "Сохранить",
      cancel: "Отмена",
      edit: "Редактировать",
      delete: "Удалить",
      attachFiles: "Прикрепить файлы",
      add: "Добавить",
      addNotePlaceholder: "Добавить заметку...",
      total: "Всего:",
      prevPage: "Назад",
      nextPage: "Далее",
      pageOf: "Страница {page} из {total}",
      chartDate: "Дата:",
      chartUsers: "Пользователей:",
      // timeAgo
      justNow: "только что",
      minuteAgo: "минуту назад",
      minutesAgo: "{v} мин. назад",
      hourAgo: "час назад",
      hoursAgo: "{v} ч. назад",
      dayAgo: "день назад",
      daysAgo: "{v} дн. назад",
      monthAgo: "месяц назад",
      monthsAgo: "{v} мес. назад",
      yearAgo: "год назад",
      yearsAgo: "{v} лет назад",
      // Remove user from planner
      removeUser: "Удалить из клиентов",
      removeUserConfirmTitle: "Удаление клиента",
      removeUserConfirmBody:
        "Этот пользователь станет обычным пользователем и больше не будет отображаться в вашем списке клиентов. Его персональные данные останутся в системе. Продолжить?",
      removeUserConfirm: "Удалить из клиентов",
      removeUserCancel: "Отмена",
      removeUserRemoving: "Удаление...",
      removeUserError: "Произошла ошибка при удалении клиента. Попробуйте снова.",
      removeUserSuccess: "Клиент успешно удалён.",
    },

    // ── Account (account.tsx) ────────────────────────────────
    account: {
      pageTitle: "Аккаунт планировщика",
      uploadError: "Ошибка загрузки файла: ",
      tabProperties: "Данные",
      tabDesign: "Дизайн",
      tabPayment: "Оплата",
      username: "Имя пользователя",
      yourLink: "Ваша ссылка",
      yourLinkTooltip: "Это ссылка, которую вы должны отправить клиентам, чтобы они присоединились к системе под вами",
      createdAt: "Дата создания",
      name: "Имя",
      email: "Email",
      colorPicker: "Выбор цветов",
      selectPalette: "Выберите палитру:",
      noPalette: "— Нет —",
      colorType: "Тип цвета",
      pickColor: "Выберите цвет",
      currentColor: "Текущий цвет",
      defaultColor: "Цвет по умолчанию",
      resetToDefault: "Сбросить к значениям по умолчанию",
      reset: "Сброс",
      colorPrimary: "Основной",
      colorSecondary: "Дополнительный",
      colorMenu: "Меню",
      colorBackground: "Фон",
      colorAccent1: "Акцент 1",
      colorAccent2: "Акцент 2",
      colorAccent3: "Акцент 3",
      logo: "Логотип",
      chooseFile: "Выбрать файл",
      fileChosen: "Файл выбран",
      noFileChosen: "Файл не выбран",
      pendingCancelation: "Ожидание отмены",
      canceled: "Отменён",
      testing: "Пробный период",
      active: "Активен",
      planBusiness300: "Business (до 300 пользователей)",
      planBusiness100: "Business (до 100 пользователей)",
      planBusiness: "Business",
      price300: "₪499/месяц (+НДС)",
      price100: "₪249/месяц (+НДС)",
      cancelSubscription: "Отменить подписку",
      cancelConfirmTitle: "Вы уверены?",
      cancelConfirmBody:
        'Нажатие «Отменить подписку» немедленно удалит ваш аккаунт планировщика. Все пользователи под вами (включая ваш аккаунт) станут базовыми пользователями.',
      cancelConfirmCancel: "Передумал",
      cancelError: "Произошла ошибка при отмене подписки. Попробуйте снова.",
      canceling: "Отмена...",
      cancelConfirmSubmit: "Отменить подписку",
      cancelNotice: "Запрос на отмену принят. Подписка будет активна до конца текущего расчётного периода.",
      saving: "Сохранение...",
      saveButton: "Сохранить",
      // Palette names
      paletteDefault: "По умолчанию",
      paletteSunriseWave: "Волна рассвета",
      paletteRetroTV: "Ретро ТВ",
      paletteDarkFlowers: "Тёмные цветы",
      paletteNeonFuturistic: "Неоновый футуризм",
      palettePastelBouquet: "Пастельный букет",
      paletteSantorini: "Санторини",
      paletteAlmondBlossom: "Цветение миндаля",
      palettePurpleApp: "Фиолетовое приложение",
      paletteMinimalNude: "Минимал нюд",
      paletteYellowScrewdriver: "Жёлтая отвёртка",
      paletteNaturalStone: "Натуральный камень",
      paletteRetroCrowd: "Ретро толпа",
      paletteForestAnimals: "Лесные животные",
      paletteOceanDepths: "Морские глубины",
      paletteRedDeer: "Красный олень",
      paletteArtGallery: "Арт-галерея",
      paletteWarmPortrait: "Тёплый портрет",
      paletteModernVehicle: "Современный автомобиль",
      paletteBrightYellow: "Яркий жёлтый",
      paletteEarth: "Земля",
      palettePomegranate: "Гранат",
    },

    // ── Insights (insights.tsx, insights.new-ai.tsx, insights.$insightId.tsx) ─
    insights: {
      editInsightsTitle: "Редактирование инсайтов",
      createInsight: "Создать инсайт",
      triggerDescription: "Описание триггера",
      summary: "Краткое описание",
      status: "Статус",
      approvedAndActive: "Одобрен и активен",
      approvedAndInactive: "Одобрен и неактивен",
      pendingApproval: "Ожидает одобрения",
      rejectedStatus: "Отклонён",
      rejectionReasonLabel: "Причина отклонения",
      activeStatus: "Активен",
      inactiveStatus: "Неактивен",
      newAiInsightTitle: "Новый инсайт — AI",
      createInsightButton: "Создать инсайт",
      editInsightTitle: "Редактирование инсайта",
      saveChanges: "Сохранить изменения",
      somethingWentWrong: "Что-то пошло не так",
    },

    // ── Resources (resources.tsx) ────────────────────────────
    resources: {
      pageTitle: "Ресурсы для планировщика",
      description: "На этой странице вы найдёте маркетинговые материалы для финансовых планировщиков.",
      goToCanva: "Перейти к ресурсам в Canva",
    },

    // ── Invite agent (InviteAgent.tsx) ───────────────────────
    inviteAgent: {
      inviteFailed: "Приглашение не отправлено",
      inviteFailedDetails: "Произошла ошибка при отправке приглашения",
      confirm: "OK",
      agentCodeRequired: "Код агента обязателен",
      agentCodeInvalid: "Код агента должен содержать только строчные латинские буквы, цифры и дефисы",
      inviteFailedTo: "Произошла ошибка при отправке приглашения для ",
      inviteSucceeded: "Приглашение отправлено успешно",
      inviteSucceededTo: "Приглашение агента успешно отправлено для ",
      inviteNewAgent: "Пригласить нового агента",
      createAgentAndInvite: "Создайте нового агента и пригласите пользователя для управления",
      inviteUserSection: "Приглашение пользователя",
      infoBox: "Вы можете пригласить пользователей, которые ещё не зарегистрированы в системе. Приглашение будет ожидать их и появится при присоединении к системе.",
      userEmailLabel: "Email пользователя для приглашения",
      userEmailTooltip: "Это email пользователя, который будет управлять аккаунтом агента",
      agentCodeLabel: "Код агента (на английском)",
      agentCodeTooltip:
        "Код агента должен содержать только строчные буквы (a-z), цифры (0-9) и дефисы (-). Примеры: john-doe, agent123, my-agent",
      agentCodeNote: "Код агента — это его уникальный идентификатор в системе, определяющий ссылку, которой он делится с пользователями для присоединения.",
      agentCodeExample: "Пример:",
      agentCodeExampleCode: "Код:",
      agentCodeExampleLink: "Ссылка-приглашение:",
      agentEmailLabel: "Email агента (необязательно)",
      agentEmailTooltip: "Лиды из системы будут отправляться на этот email",
      agentNameLabel: "Имя агента (необязательно)",
      agentLogoLabel: "Логотип агента (необязательно)",
      chooseFile: "Выбрать файл",
      fileChosen: "Файл выбран",
      noFileChosen: "Файл не выбран",
      createAndInviteButton: "Создать и пригласить",
    },

    // ── Masleka purchase modal (MaslekaPurchaseModal.tsx) ────
    maslekaPurchase: {
      modalTitle: "Покупка пенсионных маслек для клиентов",
      description: "Введите количество маслек, которые хотите приобрести",
      decreaseQty: "Уменьшить количество",
      increaseQty: "Увеличить количество",
      upTo20: "До 20 маслек",
      above20: "Более 20 маслек",
      perRenewable: "за возобновляемую маслеку",
      renewableInfo: "Маслека обновляется ежемесячно в течение года (12 запросов)",
      priceNote: "Мы знаем, что вы платите ₪14 за маслеку. Здесь речь идёт о 12 маслеках, так что цена отличная!",
      savedDiscount: "Вы сэкономили ₪{amount} благодаря скидке!",
      totalCost: "Общая стоимость",
      receiptNameLabel: "Имя в квитанции",
      receiptNamePlaceholder: "Имя и фамилия",
      proceedToPayment: "Перейти к оплате",
      cancelButton: "Отмена",
    },

    // ── Masleka Management (MaslekaManagement.tsx) ───────────
    maslekaManagement: {
      clientsAndBudget: "Управление клиентами и бюджетом",
      maslekaSettings: "Настройки маслеки",
      maslekaManagement: "Управление маслекой",
      defaultPaymentMode: "Способ оплаты по умолчанию",
      canChangePerClient: "Можно изменить для каждого клиента отдельно",
      canChangePerClientLater: "Вы можете изменить эту настройку для каждого клиента индивидуально позже",
      paymentInfo: "Оплата за год пенсионной маслеки (12 запросов). Данные обновляются ежемесячно и поступают в течение 3 рабочих дней.",
      customersWillPay: "Клиенты оплачивают",
      customersWillPayDesc: "Они оплатят ₪35 перед каждым запросом маслеки",
      iWillPay: "Я оплачиваю",
      iWillPayDesc: "Согласно настроенному бюджету",
      alerts: "Уведомления",
      notifyOnOrder: "Уведомлять, когда клиент заказывает маслеку",
      saving: "Сохранение...",
      save: "Сохранить",
      purchasedCount: "Куплено маслек",
      usedCount: "Использовано маслек",
      remainingBalance: "Остаток",
      missingDetails: "Отсутствуют персональные данные. Хотите обновить их сейчас?",
      purchaseBudget: "Покупка бюджета маслек",
      clientName: "Имя клиента",
      email: "Email",
      joinDate: "Дата присоединения",
      maslekaPayment: "Оплата маслеки",
      markAll: "Выбрать всё",
      statusCol: "Статус",
      infoStatus: "Статус информации",
      dataArrived: "Данные получены",
      dataOnTheWay: "Данные в пути",
      processCanceled: "Процесс был отменён",
      processStarted: "Процесс начат",
      notOrdered: "Маслека не заказана",
      registered: "Зарегистрирован в маслеке",
      noClients: "Нет клиентов для отображения.",
      quotaExhaustedTitle: "Бюджет маслек исчерпан!",
      quotaExhaustedDesc: "Ваш бюджет маслек израсходован. Рекомендуем приобрести ещё.",
      dontShowAgain: "Больше не показывать",
      purchaseMore: "Купить ещё маслек",
      free: "Бесплатно",
      notActive: "Неактивен",
      saveError: "Не удалось сохранить, попробуйте ещё раз",
    },

    // ── Masleka route (masleka.tsx) ─────────────────────────────
    maslekaRoute: {
      pensionClearingReceipt: "Пенсионная маслека",
    },

    // ── Insight Tab Navigation ────────────────────────────────
    insightTabs: {
      assetInsights: "Инсайты по активам",
      cashflowInsights: "Инсайты по денежным потокам",
      cannotChangeType: "Невозможно изменить тип инсайта при редактировании",
    },

    // ── AI Trigger Form (AITriggerForm.tsx) ───────────────────
    aiTriggerForm: {
      assetInsight: "Инсайт по активам",
      cashflowInsight: "Инсайт по денежным потокам",
      assetInsightDesc: "Инсайт будет основан на активах и обязательствах пользователя, но не на данных денежного потока",
      cashflowInsightDesc: "Инсайт будет основан на денежном потоке пользователя: все транзакции по кредитным картам и банковским счетам",
      readOnly: "Только для чтения",
      approvedAISettings: "Утверждённые настройки AI",
      approvedAISettingsDesc: "Настройки AI для этого инсайта утверждены и не могут быть изменены. Вы можете просмотреть настройки для справки или отозвать утверждение для редактирования.",
      aiTrigger: "AI-триггер",
      aiTriggerTooltipAssets: "Опишите условие, при котором должен появиться инсайт. Например: «Если на банковском счёте более 100 000 шекелей»",
      aiTriggerTooltipCashflow: "Опишите условие, при котором должен появиться инсайт на основе транзакций. Например: «Если в этом месяце более 5 транзакций в ресторанах»",
      aiTriggerPlaceholderAssets: "Пример: Если на банковском счёте более 50 000 шекелей",
      aiTriggerPlaceholderCashflow: "Пример: Если в этом месяце более 10 транзакций в ресторанах",
      extraDataLabel: "Дополнительные данные для AI",
      extraDataTooltip: "Дополнительная информация для более точной генерации кода AI. Например: список пенсионных провайдеров, ключевые слова в транзакциях и т.д.",
      extraDataPlaceholderAssets: "Пример: Список пенсионных провайдеров: Мигдаль, Харель, Кляль, Менора Мивтахим",
      extraDataPlaceholderCashflow: "Пример: Ключевые слова ресторанов: Макдоналдс, Бургер Кинг, Пицца Хат, Домино'с",
      customParams: "Пользовательские параметры",
      customParamsTooltip: "Параметры, которые функция вернёт помимо обычного результата. Каждый параметр отображается с идентификатором {1}, {2} и т.д.",
      paramDescription: "Описание параметра...",
      remove: "Удалить",
      addParam: "Добавить параметр",
      checking: "Проверка...",
      checkAndGenerate: "Проверить и сгенерировать код",
    },

    // ── Insight Main Form (InsightMainForm.tsx) ───────────────
    insightMainForm: {
      insightSettings: "Настройки инсайта",
      approvedInsight: "Утверждённый инсайт",
      approvedInsightDesc: "Этот инсайт утверждён, поэтому большинство полей заблокированы. Вы можете только изменить статус активности, отозвать утверждение или удалить инсайт.",
      activeStatus: "Статус активности",
      activeStatusTooltip: "Здесь вы можете указать, должен ли инсайт отображаться. Если отмечено, инсайт будет показан клиентам. Если нет — не будет показан.",
      triggerDescription: "Описание триггера",
      triggerDescriptionTooltip: "Краткое описание условия, запускающего инсайт. Отображается в таблице инсайтов.",
      summary: "Краткое описание",
      summaryTooltip: "Это короткое уведомление, которое появится у клиента. При нажатии откроется полный инсайт.",
      title: "Заголовок",
      titleTooltip: "Это заголовок инсайта. Желательно одна-две строки.",
      body: "Содержание",
      bodyTooltip: "Это тело инсайта. Оно должно чётко отличаться от заголовка.",
      buttonText: "Текст кнопки",
      buttonTextTooltip: "Короткий текст, который будет на кнопке.",
      externalLink: "Внешняя ссылка кнопки",
      externalLinkTooltip: "Это ссылка кнопки. Если указана, клиент будет перенаправлен по ней.",
      podcastUrl: "URL подкаста",
      podcastUrlTooltip: "Ссылка на подкаст (необязательно)",
      videoUrl: "URL видео",
      videoUrlTooltip: "Ссылка на внешнее видео (необязательно)",
      iframeUrl: "URL встроенного видео",
      iframeUrlTooltip: "Ссылка на видео, отображаемое внутри инсайта слева.",
      reportText: "Текст отчёта",
      reportTextTooltip: "Сокращённый текст для отчётов и планировщиков. Содержит ключевую информацию инсайта в профессиональном и кратком формате.",
      reportTextPlaceholder: "Сокращённый текст для отчётов и планировщиков...",
      updating: "Обновление...",
      updateStatus: "Обновить статус",
      savingEllipsis: "Сохранение...",
      disableApproval: "Отозвать утверждение",
      disableApprovalConfirm: "Вы уверены, что хотите отозвать утверждение? Это позволит редактирование, но деактивирует инсайт для пользователей до повторного утверждения.",
      deleteInsight: "Удалить инсайт",
      deleteInsightConfirm: "Вы уверены, что хотите удалить этот инсайт? Это также удалит все связанные инсайты пользователей.",
      restoreDefault: "Восстановить инсайт по умолчанию",
      hebrewTab: "עברית",
      englishTab: "English",
    },
  },
};
